var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Doc',{staticClass:"my-8"}),_c('SelfDeliv',{staticClass:"my-8"}),_c('Tiers',{staticClass:"my-8"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }